import { Reveal } from "../components/Reveal";
import { PageHero } from "../components/PageHero";
import { CONTACT } from "../lib/site";
import { useT } from "../context/LangContext";
import { EnvelopeSimple, Phone } from "@phosphor-icons/react";

export default function Contatti() {
  const { t } = useT();
  const c = t.contact;
  const items = [
    { icon: EnvelopeSimple, label: c.emailLabel, value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: Phone, label: c.phoneLabel, value: CONTACT.phone, href: `tel:${CONTACT.phone.replace(/\s/g, "")}` },
  ];
  return (
    <>
      <PageHero kicker={c.heroKicker} titleLines={c.heroTitleLines} intro={c.heroIntro} />

      <section className="mx-auto max-w-7xl px-5 md:px-8 py-12 md:py-16" data-testid="contact-section">
        <div className="grid gap-5 sm:grid-cols-2 content-start max-w-4xl">
          {items.map((it, i) => (
            <Reveal key={it.label} delay={i * 0.08}>
              <div className="h-full rounded-2xl border border-border bg-surface p-7">
                <it.icon size={32} weight="duotone" className="text-terracotta mb-4" />
                <div className="font-display font-bold tracking-widest text-xs text-forest mb-2">{it.label.toUpperCase()}</div>
                {it.href ? (
                  <a href={it.href} data-testid={`contact-${i}`} className="text-lg text-ink hover:text-terracotta transition-colors duration-200 break-words">{it.value}</a>
                ) : (
                  <span className="text-lg text-ink">{it.value}</span>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
